/** Chapters of the animated Tearsheets landing tour (pill labels + caption card copy). */

export type LandingStageId = 'reports' | 'grid' | 'stencil' | 'skin' | 'layout' | 'branding' | 'create' | 'workflow' | 'pdf';

export type LandingStage = {
  id: LandingStageId;
  title: string;
  caption: string;
};

export const LANDING_STAGES: readonly LandingStage[] = [
  {
    id: 'reports',
    title: 'Fund board',
    caption: 'Every fund and month at a glance. Filter Status to Missing to find months that still need a tearsheet.',
  },
  {
    id: 'grid',
    title: 'Layout grid',
    caption: 'Pick a layout, drop a stencil into an empty grid cell, resize it, and drag cards into place.',
  },
  {
    id: 'stencil',
    title: 'Edit stencil',
    caption: 'Open a stencil editor to choose which Performance Statistics rows appear on the page.',
  },
  {
    id: 'skin',
    title: 'Custom skin',
    caption: 'Try stock skins, then create your own palette in the Skins menu with a live preview.',
  },
  {
    id: 'layout',
    title: 'Save & favorite',
    caption: 'Copy the stock layout, name it, save it, and pin it to your favorite layouts.',
  },
  {
    id: 'branding',
    title: 'Branding',
    caption: 'Fonts, header, logo, disclaimer, benchmarks, and portfolio manager. Set once for every tearsheet.',
  },
  {
    id: 'create',
    title: 'Create',
    caption: 'Pick the fund and month. The report uses your saved layout, skin, and branding.',
  },
  {
    id: 'workflow',
    title: 'Review & publish',
    caption: 'Move the draft through Submit, Approve, and Publish.',
  },
  {
    id: 'pdf',
    title: 'PDF export',
    caption: 'Export Letter continuous or paginated A4 without cutting stencils.',
  },
];
